import { STARTPAGE_BASE_URL } from 'Frontend/constants/endpoint'
import { IStartpageResult } from '../models/startpage.model'

export async function getCommunityStartpage(pageIndex: number): Promise<IStartpageResult> {
  let response = await fetch(`${STARTPAGE_BASE_URL}/getcommunitycontent?pageIndex=${pageIndex}&pageSize=20`)

  const jsonResults = await response.json()
  return <IStartpageResult>jsonResults
}
